import { getLocationChangeWatcher } from './location-change.saga';
import { getActiveEntityChangeWatcher } from './active-entity-change.saga';

export default [
  getLocationChangeWatcher(),
  getActiveEntityChangeWatcher(),
];
